import React, { createContext, useContext } from "react";
import { useCoreService } from "../services/Core.service";

let operationsAllowed: any = {};
const CoreFacadeContext = createContext(operationsAllowed);

export const CoreFacadeProvider = (props: any) => {
  const coreService = useCoreService();

  const setupApplication = () => {
    coreService.setupApplication();
  };

  const updateLanguage = (language: string) => {
    coreService.updateLanguage(language);
  };

  const getLanguage = () => {
    return coreService.getLanguage();
  };

  const getFullName = (firstName: string, lastName: string) => {
    return coreService.getFullName(firstName, lastName);
  };

  const getInitialsOfFullName = (firstName: string, lastName: string) => {
    return coreService.getInitialsOfFullName(firstName, lastName);
  };

  operationsAllowed = {
    setupApplication,
    updateLanguage,
    getLanguage,
    getFullName,
    getInitialsOfFullName
  };

  return (
    <CoreFacadeContext.Provider value={operationsAllowed}>
      {props.children}
    </CoreFacadeContext.Provider>
  );
};

export const useCoreFacade = () => {
  return useContext(CoreFacadeContext);
};
